import { Dispatcher } from '../../lib';
import { LinkHandler } from './handler';

export default new Dispatcher('link-handling', LinkHandler);
